module.exports = __webpack_public_path__ + "static/media/1 15 ogsa.d725d962.mp3";